// extracted by mini-css-extract-plugin
export var shyHeader = "vSmzW";
export var shyHeaderGripper = "Hkcb1";
export var shyHeaderOverlay = "BIbax";